import { Switch } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

const AudioPlaybackTestSwitch = ({
	showAudioPlaybackTestDialog,
	toggleAudioPlaybackTestDialog,
}: {
	showAudioPlaybackTestDialog: boolean;
	toggleAudioPlaybackTestDialog: () => void;
}) => {
	const theme = useAppTheme();

	return (
		<Switch
			value={showAudioPlaybackTestDialog}
			onChange={(e) => {
				e.stopPropagation();
				toggleAudioPlaybackTestDialog();
			}}
			color={theme.colors.secondary}
		/>
	);
};

export default AudioPlaybackTestSwitch;
